export default __webpack_public_path__ + "static/media/ADA.cb6994d1.svg";